module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('div', {
    staticClass: "auth"
  }, [_c('img', {
    staticClass: "i300",
    attrs: {
      "alt": "author photo",
      "src": "image/1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiv",
      "title": "iv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_about",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Stephanie Woodfield (Orlando, FL) has been a practicing Pagan for over twenty years. A devotional polytheist, teacher, and priestess of the Morrigan, she is one of the founding members of Morrigu’s Daughters and is an organizer for several Pagan gatherings. Stephanie teaches classes on devotional work and magical practice in the United States and internationally. A longtime New Englander, she now resides in the Orlando area with her husband, a very pampered cat, and various reptiles. She is called to helping others forge meaningful experiences with the Morrigan, as well as the gods and land of Ireland.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b468657","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 57
// module chunks = 0